<template>
  <b-modal
    id="trash-modal"
    ok-only
    scrollable
    centered
    ok-title="Esci"
    title="Cestino"
    size="xl"
    @show="getTrashedFiles"
  >
    <MyLoading :loading-show="loadingShow" />

    <p class="mx-md-3 mx-sm-1 mb-0 text-muted">
      Gli elementi eliminati sono recuperabili per 5 anni dalla data di eliminazione.
    </p>

    <div class="mx-md-3 mx-sm-1 py-1">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        style="border: none"
        variant="outline-primary"
        @click="getTrashedFiles"
      >
        <font-awesome-icon
          icon="arrows-rotate"
          size="lg"
        />
      </b-button>
      <b-form-group
        class="mb-0"
        label-align-sm="right"
        label-cols-sm="8"
        label-for="filter-input"
        label-size="sm"
      >
        <b-input-group>
          <b-form-input
            id="filter-input"
            v-model="filter"
            placeholder="Cerca"
            type="search"
          />

          <b-input-group-append>
            <b-button
              :disabled="!filter"
              class="btn-warning"
              @click="filter = ''"
            >
              Svouta
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>

    <vue-custom-scrollbar
      class="scroll-area"
      :settings="settings"
      style="height: 70vh"
    >

      <div class="my-card mx-md-3 mx-sm-1 text-center content-center" />
      <BContainer
        name="trash-container"
        class="d-flex justify-content-start flex-wrap"
        style="height:500px"
      >
        <div
          v-for="file in filteredTrashedFiles"
          :key="file.id"
          class="my-card mx-md-3 mx-sm-1 text-center content-center"
        >
          <FileCard
            :file="file"
            :trashed="true"
            :selected-files="selectedTrashedFiles"
            @select="selectFile"
          />
        </div>
      </BContainer>
    </vue-custom-scrollbar>
  </b-modal>
</template>

<script>
import {
  BModal, BButton, BContainer, BFormGroup, BInputGroup, BInputGroupAppend, BFormInput,
} from 'bootstrap-vue'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import FileCard from '@/layouts/components/FileCard.vue'
import MyLoading from '@/layouts/components/MyLoading.vue'
import Ripple from 'vue-ripple-directive'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'

const objectsRepository = RepositoryFactory.get('objects')

export default {
  name: 'TrashModal',
  directives: {
    Ripple,
  },
  components: {
    vueCustomScrollbar,
    MyLoading,
    BModal,
    BButton,
    BContainer,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    FileCard,
  },
  data() {
    return {
      trashedFiles: [],
      loadingShow: false,
      settings: {
        suppressScrollX: true,
      },
      filter: null,
    }
  },
  computed: {
    selectedTrashedFiles() {
      return this.trashedFiles.filter(file => file.selected === true)
    },
    filteredTrashedFiles() {
      if (this.filter == null) {
        return this.trashedFiles
      }
      return this.trashedFiles.filter(file => file.label.toLowerCase().includes(this.filter.toLowerCase()))
    },
  },
  methods: {
    async getTrashedFiles() {
      this.loadingShow = true
      this.$emit('empty-trash-selected')

      try {
        const response = await objectsRepository.indexTrashed()
        const { data } = response
        if (data.code) {
          this.trashedFiles = data.data.objects
        } else {
          this.apiErrors.notifyApiError(response)
        }
      } catch (e) {
        this.apiErrors.notifyApiError(e)
      } finally {
        this.loadingShow = false
      }
    },
    selectFile(file) {
      this.$set(file, 'selected', !file.selected)
      this.$emit('trash-select', file.id)
    },
    removeRestored(ids) {
      const removed = this.trashedFiles.filter(f => ids.includes(f.id))
      this.trashedFiles = this.trashedFiles.filter(f => !ids.includes(f.id))
      return removed
    },
  },
}
</script>

<style scoped>
.my-card {
  width: 13rem;
}
</style>
